export enum StatusPageManageTabs {
  GENERAL = "general",
  DESIGN = "design",
  COMPONENTS = "components",
  SYSTEM_METRICS = "system-metrics",
  INCIDENTS = "incidents",
  MAINTENANCE = "maintenance",
  SUBSCRIBERS = "subscribers",
  SSO = "sso",
  EXTERNAL_USERS = "external-users",
}
